import * as XLSX from "xlsx";
import { saveAs } from "file-saver"; // 인터페이스 경로 맞춰주세요
import { ParcelOrder } from "../../interfaces/ParcelOrder";
import { formatKst, utcDate } from "../../utils/utcToKst";

function orderTimeMs(createdAt: ParcelOrder["createdAt"]): number {
  const d =
    createdAt instanceof Date ? createdAt : utcDate(String(createdAt));
  const t = d.getTime();
  return Number.isNaN(t) ? 0 : t;
}

export const downloadOrdersExcel = (orders: ParcelOrder[]) => {
  const sortedByRecent = [...orders].sort(
    (a, b) => orderTimeMs(b.createdAt) - orderTimeMs(a.createdAt),
  );

  // 1. 각 상품을 한 행으로 변환 (주문은 주문일시 최신순)
  const rows = sortedByRecent.flatMap((order) =>
    order.parcelProducts.map((product) => ({
      주문번호: order.orderNumber,
      주문일자: formatKst(order.createdAt),
      수취인명: order.customerName,
      수취인전화번호: order.phoneNumber,
      주소: `${order.address} ${order.detailAddress}`,
      상품명: product.name,
      수량: product.quantity,
      실결제금액: product.finalPrice,
      단가: product.unitPrice,
      상품코드: product.productCode,
    })),
  );

  // 2. 워크시트 생성
  const worksheet = XLSX.utils.json_to_sheet(rows);

  // 3. 워크북 생성
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "배송정보");

  // 4. 엑셀 파일 생성 & 다운로드
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `배송정보_${new Date().toISOString().split("T")[0]}.xlsx`);
};
